import { TFunction } from 'i18next'
import i18n from '../../../i18n'
import { CampaignQuietHours } from '../../../types'

function formatTime(hhmm: string): string {
    const [h, m] = hhmm.split(':').map(Number)
    const date = new Date(2000, 0, 1, h, m)
    return date.toLocaleTimeString(i18n.language, {
        hour: 'numeric',
        minute: '2-digit',
    })
}

export function quietHoursLabel(quietHours: CampaignQuietHours, t: TFunction): string {
    const start = formatTime(quietHours.start)
    const end = formatTime(quietHours.end)
    const action = quietHours.action === 'skip'
        ? t('quiet_hours_action_skip')
        : t('quiet_hours_action_delay')
    return `${start} – ${end} (${action})`
}
